// 自定义select下拉框滚动加载更多数据的自定义指令
const selectMore = {
  bind(el, binding) {
    const SELECTWRAP_DOM = el.querySelector('.ivu-select-dropdown');
    SELECTWRAP_DOM.addEventListener('scroll', function () {
      const CONDITION = this.scrollHeight - this.scrollTop - 100 <= this.clientHeight;
      if (CONDITION) {
        binding.value();
      }
    });
  }
};

export {
  selectMore
};